import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kumd7c4ksq: FaireBrandEntity = {
  token: "b_kumd7c4ksq",
  type: "brand",
  name: "Ginger Lab",
  avatarUrl:
    "https://cdn.faire.com/fastly/a2aa877b518cea25e6640783022a87c338b7fc9f0c2def5b5202ee82914092ad.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/20ce94c87d7ee28dc791dd955d1341c8423dd46f30aa06aab87962b811b13f9b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a2aa877b518cea25e6640783022a87c338b7fc9f0c2def5b5202ee82914092ad.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/20ce94c87d7ee28dc791dd955d1341c8423dd46f30aa06aab87962b811b13f9b.jpeg",
  location: "Santa Clara, CA, USA",
  minimumOrderDollars: 125,
  rating: 4.9,
  reviewCount: 13,
  isInsider: true,
  description:
    "Our founder, Deb, started Ginger Lab because she loves a good cocktail and wanted to have a better ginger beer for the cocktail recipes that called for it. She found that the common denominator to all the cocktails that she constantly gravitated towards called for ginger beer as an ingredient, but she just couldn't tolerate the ones available in the stores. In creating a ginger beer that suited her palate, Deb discovered that it was great on its own and that ginger actually paired well with a variety of fruits that she loved too - hence the fruit-based ginger beers. She started out by testing her brews at a food truck event with complete strangers and it was well received. From there, Deb was itching to move away from tech and work on something more creative, more hands on and more adventurous. She was also at a point in her career where the timing couldn't have been any better and so she decided to take the leap and bet on herself. Ginger Lab was \"born\" in May 2016 and Deb and her small team has since graduated from operating out of a shared commercial kitchen to their own production facility in Santa Clara, CA.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.288Z",
    importedBy: "entity-db-cli",
  },
};
